import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

// Interface for firmware files
interface FirmwareFile {
  name: string;
  path: string;
  uploadedAt?: string;
}

interface AllBinsModalProps {
  show: boolean;
  onClose: () => void;
  firmwareFiles: FirmwareFile[];
  onDelete: (fileName: string) => void;
  apiBaseUrl: string;
}

const AllBinsModal: React.FC<AllBinsModalProps> = ({
  show,
  onClose,
  firmwareFiles,
  onDelete,
  apiBaseUrl
}) => {
  if (!show) {
    return null;
  }

  return (
    <>
      <div className="modal-backdrop fade show" onClick={onClose}></div>
      <div className="modal fade show" style={{ display: 'block' }} tabIndex={-1} role="dialog">
        <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">All Binary Files</h5>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {firmwareFiles.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>Filename</th>
                        <th>Path</th>
                        <th>Uploaded</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {firmwareFiles.map((file, index) => (
                        <tr key={index}>
                          <td>{file.name}</td>
                          <td><code>{file.path}</code></td>
                          <td>{file.uploadedAt ? new Date(file.uploadedAt).toLocaleString() : 'Unknown'}</td>
                          <td>
                            <a 
                              href={`${apiBaseUrl}${file.path}`} 
                              className="btn btn-sm btn-outline-primary me-2"
                              target="_blank"
                              rel="noopener noreferrer"
                              download
                              title="Download"
                            >
                              <FontAwesomeIcon icon={faDownload} />
                            </a>
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => {
                                onDelete(file.name);
                                // Close modal if last file is deleted
                                if (firmwareFiles.length === 1) {
                                  onClose();
                                }
                              }}
                              title="Delete"
                            >
                              <FontAwesomeIcon icon={faTrashAlt} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="text-center py-3">
                  <p className="text-muted mb-0">No firmware files available.</p>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <div className="text-muted me-auto">
                <small>Total: {firmwareFiles.length} files</small>
              </div>
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllBinsModal;